import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  getFirstAccessibleAdminPath,
  hasPermission,
} from "../utils/permissions.js";

import HomePage from "../components/Home";
import ProductPage from "../components/ProductDetailsPage";
import CategoryPage from "../components/CategoryPage";
import CartPage from "../components/CartPage";
import AdminLogin from "../pages/Auth/Login.jsx";
import Dashboard from "../pages/Dashboard/Dashboard";
import Employees from "../pages/Employees/EmployeeList";
import EmployeeAdvancesPage from "../pages/Employees/EmployeeAdvancesPage";
import Attendance from "../pages/Attendance/Attendance";
import Payroll from "../pages/Payroll/Payroll";
import PayrollReports from "../pages/Reports/PayrollReport";
import Settings from "../pages/Settings/Settings";
import Rolepermissions from "../pages/Settings/Rolepermissions";
import Departments from "../pages/Settings/Departments";
import Branches from "../pages/Settings/Branches";
import Profile from "../pages/Profile/Profile";
import AdminLayout from "../layouts/AdminLayout";
import AddEmployee from "../pages/Employees/AddEmployee";
import EmployeeDetails from "../pages/Employees/EmployeeDetails";
import DailyAttendance from "../pages/Attendance/DailyAttendance";
import MonthlyAttendance from "../pages/Attendance/MonthlyAttendance";
import AttendanceCorrections from "../pages/Attendance/AttendanceCorrections";
import LeaveRequests from "../pages/Leave/LeaveRequests";
import ApplyLeave from "../pages/Leave/ApplyLeave";
import LeaveDetails from "../pages/Leave/LeaveDetails";
import LeaveBalance from "../pages/Leave/LeaveBalance";
import GeneratePayroll from "../pages/Payroll/GeneratePayroll";
import Payslips from "../pages/Payroll/Payslips";
import PayslipDetails from "../pages/Payroll/PaySlipDetails";
import AttendanceReport from "../pages/Reports/AttendanceReport";
import EmployeeReport from "../pages/Reports/EmployeeReport";
import DesignationManagement from "../pages/Settings/DesignationManagement";
import AuthLayout from "../layouts/AuthLayout";
import AuthPage from "../components/SignInPage";
import SearchResultsPage from "../components/SearchResultsPage";
import MastersDashboard from "../pages/Masters/MasterDashboard";
import BrandsPage from "../pages/Masters/BrandsPage";
import CategoriesPage from "../pages/Masters/CategoriesPage";
import ColorsPage from "../pages/Masters/ColorsPage";
import SizesPage from "../pages/Masters/SizesPage";
import StoresPage from "../pages/Masters/StoresPage";
import SuppliersPage from "../pages/Masters/SuppliersPage";
import CommercialAgreementsPage from '../pages/Masters/CommercialAgreementsPage';
import AccountingPage from '../pages/Accounting/AccountingPage';
import LedgerStatement from '../pages/Accounting/LedgerStatement';
import PartyAccounts from '../pages/Accounting/PartyAccounts';
import PostingSetup from '../pages/Accounting/PostingSetup';
import SalesSetup from '../pages/Accounting/SalesSetup';
import SalesSnapshots from '../pages/Accounting/SalesSnapshots';
import TenderClearing from '../pages/Accounting/TenderClearing';
import PurchaseInvoices from '../pages/Accounting/PurchaseInvoices';
import SisLiabilities from '../pages/Accounting/SisLiabilities';
import SupplierReturns from '../pages/Accounting/SupplierReturns';
import SubCategoriesPage from "../pages/Masters/SubCategoryPage";
import UnitsPage from "../pages/Masters/UnitsPage";
import SeasonsPage from "../pages/Masters/SeasonsPage";
import ProductsPage from "../pages/Masters/Products/ProductsPage";
import ProductsForm from "../pages/Masters/Products/ProductsForm";
import ProductProfile from "../pages/Masters/Products/ProductProfile";
import Overview from "../pages/Inventory/Overview";
import StockAdjustment from "../pages/Inventory/StockAdjustment";
import StockLedger from "../pages/Inventory/StockLedger";
import StockTransferPage from "../pages/Inventory/StockTransfer";
import StockCount from "../pages/Inventory/StockCount";
import LowStock from "../pages/Inventory/LowStock";
import StockValuationPage from "../pages/Inventory/StockValuationPage";
import OnlinePricingPage from '../pages/Inventory/OnlinePricingPage';
import BarcodeLabelsPage from "../pages/Inventory/BarcodeLabelsPage";
import PurchaseOrdersPage from "../pages/Purchases/PurchaseOrders";
import CreatePurchaseOrderPage from "../pages/Purchases/CreatePurchaseOrder";
import PurchaseOrderDetailsPage from "../pages/Purchases/PurchaseOrderDetails";
import GRNCreatePage from "../pages/Purchases/GRNCreatePage";
import GRNListPage from "../pages/Purchases/GRNList";
import GRNDetailsPage from "../pages/Purchases/GRNDetailsPage";
import SizeSellThroughReportPage from "../pages/ReportsCenter/SizeSellThroughReportPage";
import ReorderStockCoverReportPage from "../pages/ReportsCenter/ReorderStockCoverReportPage";
import DeadStockReportPage from "../pages/ReportsCenter/DeadStockReportPage";
import BrandTradingReportPage from "../pages/ReportsCenter/BrandTradingReportPage";
import CounterShiftReportPage from "../pages/ReportsCenter/CounterShiftReportPage";
import GrnReconciliationReportPage from "../pages/ReportsCenter/GrnReconciliationReportPage";
import PriceGrnAuditReportPage from "../pages/ReportsCenter/PriceGrnAuditReportPage";
import OnlineFulfilmentReportPage from "../pages/ReportsCenter/OnlineFulfilmentReportPage";
import AttendanceExceptionsReportPage from "../pages/ReportsCenter/AttendanceExceptionsReportPage";
import AdvanceOutstandingReportPage from "../pages/ReportsCenter/AdvanceOutstandingReportPage";
import TransferReconciliationReportPage from "../pages/ReportsCenter/TransferReconciliationReportPage";
import SlowMovingReportPage from "../pages/ReportsCenter/SlowMovingReportPage";
import CouponPerformanceReportPage from "../pages/ReportsCenter/CouponPerformanceReportPage";
import CustomerRetentionReportPage from "../pages/ReportsCenter/CustomerRetentionReportPage";
import CatalogueExceptionsReportPage from "../pages/ReportsCenter/CatalogueExceptionsReportPage";
import CustomReportsPage from "../pages/ReportsCenter/CustomReportsPage";
import SupplierReturnsPage from "../pages/Purchases/SupplierReturnsPage";
import CreateSupplierReturnPage from "../pages/Purchases/CreateSupplierReturn";
import SupplierReturnDetailsPage from "../pages/Purchases/SupplierReturnDetails";
import PurchaseDashboard from "../pages/Purchases/PurchaseDashboard";
import ToolsDashboard from "../pages/Tools/ToolsDashboard";
import ImportCenterPage from "../pages/Tools/ImportCenterPage";
import ImportJobReviewPage from "../pages/Tools/ImportJobReviewPage";
import ExportCenterPage from "../pages/Tools/ExportCenterPage";
import DataTemplatesPage from "../pages/Tools/DataTemplatesPage";
import ImportHistoryPage from "../pages/Tools/ImportHistoryPage";
import AuditLogsPage from "../pages/Tools/AuditLogsPage";
import BackupRestorePage from "../pages/Tools/BackupRestorePage";
import SystemJobsPage from "../pages/Tools/SystemJobsPage";
import MobileHome from "../mobileapp/Home";
import RewardsPage from "../mobileapp/Rewards";
import WalletPage from "../mobileapp/Wallet.jsx";
import ProfilePage from "../mobileapp/Profile.jsx";
import SalesDashboard from "../pages/Sales/Dashboard.jsx";
import CustomersPage from "../pages/Sales/customers/CustomersPage.jsx";
import CustomerDetail from "../pages/Sales/components/CustomerDetails.jsx";
import CreateSalesOrder from "../pages/Sales/CreateSalesOrder.jsx";
import SalesOrderList from "../pages/Sales/SalesOrderList.jsx";
import SalesOrderDetails from "../pages/Sales/SalesOrderDetails.jsx";
import DeliveryChallanList from "../pages/Dispatch/DispatchList.jsx";
import CreateDeliveryChallan from "../pages/Dispatch/CreateDeliveryChallan.jsx";
import SalesInvoiceList from "../pages/Sales/salesinvoice/SalesInvoiceList.jsx";
import SalesInvoiceDetails from "../pages/Sales/salesinvoice/SalesInvoiceDetails.jsx";
import ReceivePayment from "../pages/Sales/salesinvoice/ReceivePayment.jsx";
import SalesReturnsList from "../pages/Sales/returns/SalesReturnsList.jsx";
import CreateSalesReturn from "../pages/Sales/returns/CreateSalesReturn.jsx";
import CreditNoteDetails from "../pages/Sales/returns/CreditNoteDetails.jsx";
import SalesReturnDetails from "../pages/Sales/returns/SalesReturnDetails.jsx";
import CreditNotesList from "../pages/Sales/returns/CreditNotesList.jsx";
import POS from "../pages/Pos/POS.jsx";
import ReportsDashboard from "../pages/Reports/ReportDashboard.jsx";
import SalesReport from "../pages/Reports/SalesReports.jsx";
import BrandClaimReport from "../pages/Reports/BrandClaimReport.jsx";
import CustomerReports from "../pages/Reports/CustomerReports.jsx";
import InventoryReports from "../pages/Reports/InventoryReports.jsx";
import PurchaseReports from "../pages/Reports/PurchaseReports.jsx";
import POSReports from "../pages/Reports/POSReports.jsx";
import FinanceReports from "../pages/Reports/FinanceReports.jsx";
import GSTAnalytics from "../pages/Reports/GSTAnalytics";
import GSTReports from "../pages/ReportsCenter/GSTRegisterPage.jsx";
import SalesDetailedReportPage from "../pages/ReportsCenter/SalesDetailedReportPage.jsx";
import SalesTaxRegisterPage from "../pages/ReportsCenter/SalesTaxRegisterPage.jsx";
import SalesRegisterSummaryPage from "../pages/ReportsCenter/SalesRegisterSummaryPage.jsx";
import CashierWiseReportPage from "../pages/ReportsCenter/CashierWiseReportPage.jsx";
import StockReportPage from "../pages/ReportsCenter/StockReportPage.jsx";
import OperationalReportPage from "../pages/ReportsCenter/OperationalReportPage.jsx";
import ProductWiseSaleAndStockReportPage from "../pages/ReportsCenter/ProductWiseSaleAndStockReportPage.jsx";
import PurchaseSaleWiseReportPage from "../pages/ReportsCenter/PurchaseSaleWiseReportPage.jsx";
import GstrReportPage from "../pages/ReportsCenter/GstrReportPage.jsx";
import PurchaseReportPage from "../pages/ReportsCenter/PurchaseReportPage.jsx";
import AgentWiseSalesReportPage from "../pages/ReportsCenter/AgentWiseSalesReportPage.jsx";
import UserProfile from "../components/UserProfile.jsx";
import SizeGroupsPage from "../pages/Masters/SizeGroupsPage.jsx";
import BranchesPage from "../pages/Masters/BranchesPage.jsx";
import ProductEditPage from "../pages/Masters/Products/ProductEditPage.jsx";
import UsersPage from "../pages/Admin/Users/UsersPage.jsx";
import RolesPage from "../pages/Admin/Users/RolesPage.jsx";
import StockTransferManagementPage from "../pages/Inventory/StockTransferManagementPage.jsx";
import UnauthorizedPage from "../pages/Auth/UnauthorizedPage.jsx";
import CheckoutPage from "../components/CheckoutPage.jsx";
import ScrollToTop from "../components/common/ScrollToTop.jsx";
import { CustomerAuthProvider } from "../context/CustomerAuthContext";
import EcommerceOrdersPage from "../pages/Sales/EcommerceOrdersPage.jsx";
import PromotionsPage from "../pages/Masters/PromotionsPage.jsx";
import LeaveTypes from "../pages/Leave/LeaveTypes.jsx";
import PosProtectedRoute from "../routes/PosProtectedRoute.jsx";
import PosLogin from "../pages/Auth/PosLogin.jsx";
import PosReportsPage from "../pages/Pos/PosReportPage.jsx";
import DeliveryChallanDetails from "../pages/Dispatch/DeliveryChallanDetails.jsx";
import EditEmployee from "../pages/Employees/EditEmployee.jsx";
import TaxCatalogPage from "../pages/Masters/TaxCatalogPage.jsx";
import Home from "../mobileapp/Home";
import HdfcPaymentReturnPage from "../components/HdfcPaymentReturnPage";
import GenerateOffCyclePayroll from "../pages/Payroll/GenerateOffCyclePayroll.jsx";
import PrivacyPolicy from "../components/PrivacyPolicy.jsx";
import AccountDeletion from '../components/AccountDeletion';
import HrmsPrivacy from '../components/HrmsPrivacy';
import RefundPolicy from "../components/RefundPolicy.jsx";
import TermsConditions from "../components/TermsConditions.jsx";
import LoyaltyTerms from "../components/LoyaltyTerms.jsx";
import ShippingPolicy from "../components/ShippingPolicy.jsx";
import CashfreePaymentReturnPage from "../components/CashfreePaymentReturnPage";
import GiftCardsPage from "../components/GiftCardsPage";
import {WishlistProvider} from "../context/WishlistContext";
import SupportTicketsPage from "../pages/Support/SupportTicketsPage";
import AttendanceHolidayPoliciesPage from "../pages/Leave/AttendanceHolidayPoliciesPage";
import CreateEmployeeAdvance from "../pages/Employees/CreateEmployeeAdvances";
import EmployeeAdvanceDetailsPage from "../pages/Employees/EmployeeAdvancesDetails";
import {HRMSReportHub as HRMSReports, HRMSReportPage} from "../pages/Reports/HRMSReportPages.jsx";
import HRMSLegacyReports from "../pages/Reports/HRMSLegacyReports.jsx";
import ManageCounters from "../pages/Masters/CountersPage.jsx";
import BiometricDevices from "../pages/Attendance/BiometricDevices";
import PunchReview from "../pages/Attendance/PunchReview";
import PosBillsPage from "../pages/Sales/PosBillsPage.jsx";

// function AdminDashboardLanding() {
//   const { user } = useAuth();

//   if (hasPermission(user, "dashboard.view")) {
//     return <Dashboard />;
//   }

//   return <Navigate to={getFirstAccessibleAdminPath(user)} replace />;
// }

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <CustomerAuthProvider>
        <WishlistProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/signin" element={<div className="storefront-typography"><AuthPage initialMode="signin" /></div>} />
          <Route path="/signup" element={<div className="storefront-typography"><AuthPage initialMode="signup" /></div>} />
          <Route
            path="/pos/dashboard"
            element={
              <PosProtectedRoute>
                <POS />
              </PosProtectedRoute>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/pos/login" element={<PosLogin />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="/payment/return" element={<div className="storefront-typography"><HdfcPaymentReturnPage /></div>} />
          <Route
            path="/payment/cashfree/return"
            element={<div className="storefront-typography"><CashfreePaymentReturnPage /></div>}
          />
          <Route
            path="/"
            element={
              <AuthLayout>
                <HomePage />
              </AuthLayout>
            }
          />
          <Route path="/gift-cards" element={<AuthLayout><GiftCardsPage /></AuthLayout>} />
          <Route path="/account-deletion" element={<AuthLayout><AccountDeletion /></AuthLayout>} />
          <Route path="/hrms-privacy" element={<AuthLayout><HrmsPrivacy /></AuthLayout>} />
          <Route
            path="/privacypolicy"
            element={
              <AuthLayout>
                <PrivacyPolicy />
              </AuthLayout>
            }
          />
          <Route
            path="/refundpolicy"
            element={
              <AuthLayout>
                <RefundPolicy />
              </AuthLayout>
            }
          />
          <Route
            path="/termsandconditions"
            element={
              <AuthLayout>
                <TermsConditions />
              </AuthLayout>
            }
          />
          <Route
            path="/loyaltyterms"
            element={
              <AuthLayout>
                <LoyaltyTerms />
              </AuthLayout>
            }
          />
          <Route
            path="/shippingpolicy"
            element={
              <AuthLayout>
                <ShippingPolicy />
              </AuthLayout>
            }
          />
          <Route
            path="/userprofile"
            element={
              <AuthLayout>
                <UserProfile />
              </AuthLayout>
            }
          />
          <Route
            path="/search/:query"
            element={
              <AuthLayout>
                <SearchResultsPage />
              </AuthLayout>
            }
          />
          <Route
            path="/product/:id"
            element={
              <AuthLayout>
                <ProductPage />
              </AuthLayout>
            }
          />
          <Route
            path="/category/:catId"
            element={
              <AuthLayout>
                <CategoryPage />
              </AuthLayout>
            }
          />
          <Route
            path="/cart"
            element={
              <AuthLayout>
                <CartPage />
              </AuthLayout>
            }
          />
          <Route
            path="/checkout"
            element={
              <AuthLayout>
                <CheckoutPage />
              </AuthLayout>
            }
          />
          <Route
            path="/admindashboard"
            element={
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters"
            element={
              <AdminLayout>
                <MastersDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/pos/counters"
            element={
              <AdminLayout>
                <ManageCounters />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/pos-bills"
            element={
              <AdminLayout>
                <PosBillsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/branches"
            element={
              <AdminLayout>
                <BranchesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/tax-catalog"
            element={
              <AdminLayout>
                <TaxCatalogPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/brands"
            element={
              <AdminLayout>
                <BrandsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/categories"
            element={
              <AdminLayout>
                <CategoriesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/sub-categories"
            element={
              <AdminLayout>
                <SubCategoriesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/colors"
            element={
              <AdminLayout>
                <ColorsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/sizes"
            element={
              <AdminLayout>
                <SizesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/sizes/groups"
            element={
              <AdminLayout>
                <SizeGroupsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/units"
            element={
              <AdminLayout>
                <UnitsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/seasons"
            element={
              <AdminLayout>
                <SeasonsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/stores"
            element={
              <AdminLayout>
                <StoresPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/suppliers"
            element={
              <AdminLayout>
                <SuppliersPage />
              </AdminLayout>
            }
          />
          <Route path="/admindashboard/masters/commercial-agreements" element={<AdminLayout><CommercialAgreementsPage /></AdminLayout>} />
          <Route path="/admindashboard/accounting" element={<AdminLayout><AccountingPage /></AdminLayout>} />
          <Route path="/admindashboard/accounting/ledger-statement" element={<AdminLayout><LedgerStatement /></AdminLayout>} />
          <Route path="/admindashboard/accounting/party-accounts" element={<AdminLayout><PartyAccounts /></AdminLayout>} />
          <Route path="/admindashboard/accounting/posting-setup" element={<AdminLayout><PostingSetup /></AdminLayout>} />
          <Route path="/admindashboard/accounting/sales-setup" element={<AdminLayout><SalesSetup /></AdminLayout>} />
          <Route path="/admindashboard/accounting/sales-snapshots" element={<AdminLayout><SalesSnapshots /></AdminLayout>} />
          <Route path="/admindashboard/accounting/tender-clearing" element={<AdminLayout><TenderClearing /></AdminLayout>} />
          <Route path="/admindashboard/accounting/purchase-invoices" element={<AdminLayout><PurchaseInvoices /></AdminLayout>} />
          <Route path="/admindashboard/accounting/sis-liabilities" element={<AdminLayout><SisLiabilities /></AdminLayout>} />
          <Route path="/admindashboard/accounting/supplier-returns" element={<AdminLayout><SupplierReturns /></AdminLayout>} />
          {['setup','ledgers','vouchers','trial'].map(section=><Route key={section} path={`/admindashboard/accounting/${section}`} element={<AdminLayout><AccountingPage section={section} /></AdminLayout>} />)}
          <Route
            path="/admindashboard/masters/products"
            element={
              <AdminLayout>
                <ProductsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/online-pricing"
            element={<AdminLayout><OnlinePricingPage/></AdminLayout>}
          />
          <Route
            path="/admindashboard/inventory/barcode-labels"
            element={
              <AdminLayout>
                <BarcodeLabelsPage />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/masters/products/add"
            element={
              <AdminLayout>
                <ProductsForm />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/masters/products/:id"
            element={
              <AdminLayout>
                <ProductProfile />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/masters/products/:id/edit"
            element={
              <AdminLayout>
                <ProductEditPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/roles"
            element={
              <AdminLayout>
                <RolesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/masters/users"
            element={
              <AdminLayout>
                <UsersPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/marketing/promotions"
            element={
              <AdminLayout>
                <PromotionsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory"
            element={
              <AdminLayout>
                <Overview />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/adjustment"
            element={
              <AdminLayout>
                <StockAdjustment />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/ledger"
            element={
              <AdminLayout>
                <StockLedger />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/transfers"
            element={
              <AdminLayout>
                <StockTransferManagementPage />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/inventory/transfers/create"
            element={
              <AdminLayout>
                <StockTransferPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/count"
            element={
              <AdminLayout>
                <StockCount />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/low-stock"
            element={
              <AdminLayout>
                <LowStock />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/inventory/valuation"
            element={
              <AdminLayout>
                <StockValuationPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases"
            element={
              <AdminLayout>
                <PurchaseDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/orders"
            element={
              <AdminLayout>
                <PurchaseOrdersPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/create"
            element={
              <AdminLayout>
                <CreatePurchaseOrderPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/:id"
            element={
              <AdminLayout>
                <PurchaseOrderDetailsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/grn"
            element={
              <AdminLayout>
                <GRNListPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/grn/:id"
            element={
              <AdminLayout>
                <GRNDetailsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/grn/create"
            element={
              <AdminLayout>
                <GRNCreatePage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/returns"
            element={
              <AdminLayout>
                <SupplierReturnsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/returns/create"
            element={
              <AdminLayout>
                <CreateSupplierReturnPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/purchases/returns/:id"
            element={
              <AdminLayout>
                <SupplierReturnDetailsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales"
            element={
              <AdminLayout>
                <SalesDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/ecommerce-orders"
            element={
              <AdminLayout>
                <EcommerceOrdersPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/customers"
            element={
              <AdminLayout>
                <CustomersPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/customers/:id"
            element={
              <AdminLayout>
                <CustomerDetail />
              </AdminLayout>
            }
          />
          <Route path="/admindashboard/sales/support-tickets" element={<AdminLayout><SupportTicketsPage /></AdminLayout>} />
          <Route
            path="/admindashboard/sales/orders/create"
            element={
              <AdminLayout>
                <CreateSalesOrder />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/orders/list"
            element={
              <AdminLayout>
                <SalesOrderList />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/orders/:id"
            element={
              <AdminLayout>
                <SalesOrderDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/delivery/challan/list"
            element={
              <AdminLayout>
                <DeliveryChallanList />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/delivery/challan/create"
            element={
              <AdminLayout>
                <CreateDeliveryChallan />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/delivery/challan/:id"
            element={
              <AdminLayout>
                <DeliveryChallanDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/invoice/list"
            element={
              <AdminLayout>
                <SalesInvoiceList />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/invoice/:id"
            element={
              <AdminLayout>
                <SalesInvoiceDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/payment"
            element={
              <AdminLayout>
                <ReceivePayment />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/sales/returns"
            element={
              <AdminLayout>
                <SalesReturnsList />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/sales/returns/create"
            element={
              <AdminLayout>
                <CreateSalesReturn />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/sales/returns/:id"
            element={
              <AdminLayout>
                <SalesReturnDetails />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/sales/credit-notes"
            element={
              <AdminLayout>
                <CreditNotesList />
              </AdminLayout>
            }
          />

          <Route
            path="/admindashboard/sales/credit-notes/:id"
            element={
              <AdminLayout>
                <CreditNoteDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics"
            element={
              <AdminLayout>
                <ReportsDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/sales"
            element={
              <AdminLayout>
                <SalesReport />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/pos"
            element={
              <AdminLayout>
                <PosReportsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/customsales"
            element={
              <AdminLayout>
                <BrandClaimReport />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/customers"
            element={
              <AdminLayout>
                <CustomerReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/inventory"
            element={
              <AdminLayout>
                <InventoryReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/purchases"
            element={
              <AdminLayout>
                <PurchaseReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/pos"
            element={
              <AdminLayout>
                <POSReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/finance"
            element={
              <AdminLayout>
                <FinanceReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/gst"
            element={
              <AdminLayout>
                <GSTAnalytics />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/gst"
            element={
              <AdminLayout>
                <GSTReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/sales-detailed"
            element={
              <AdminLayout>
                <SalesDetailedReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/sales-tax-register"
            element={
              <AdminLayout>
                <SalesTaxRegisterPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/sales-register-summary"
            element={
              <AdminLayout>
                <SalesRegisterSummaryPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/cashier-wise"
            element={
              <AdminLayout>
                <CashierWiseReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/online-payments"
            element={<AdminLayout><OperationalReportPage key="online-payments" kind="online-payments" /></AdminLayout>}
          />
          <Route path="/admindashboard/reports/customer-loyalty-ledger" element={<AdminLayout><OperationalReportPage key="customer-loyalty-ledger" kind="customer-loyalty-ledger" /></AdminLayout>} />
          <Route path="/admindashboard/reports/gift-card-register" element={<AdminLayout><OperationalReportPage key="gift-card-register" kind="gift-card-register" /></AdminLayout>} />
          <Route path="/admindashboard/reports/stock-adjustment-variance" element={<AdminLayout><OperationalReportPage key="stock-adjustment-variance" kind="stock-adjustment-variance" /></AdminLayout>} />
          <Route path="/admindashboard/reports/season-wise-stock" element={<AdminLayout><OperationalReportPage key="season-wise-stock" kind="season-wise-stock" /></AdminLayout>} />
          <Route path="/admindashboard/reports/size-sell-through" element={<AdminLayout><SizeSellThroughReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/reorder-stock-cover" element={<AdminLayout><ReorderStockCoverReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/dead-stock" element={<AdminLayout><DeadStockReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/brand-trading" element={<AdminLayout><BrandTradingReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/counter-shift" element={<AdminLayout><CounterShiftReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/grn-reconciliation" element={<AdminLayout><GrnReconciliationReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/price-grn-audit" element={<AdminLayout><PriceGrnAuditReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/online-fulfilment" element={<AdminLayout><OnlineFulfilmentReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/attendance-exceptions" element={<AdminLayout><AttendanceExceptionsReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/advance-outstanding" element={<AdminLayout><AdvanceOutstandingReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/transfer-reconciliation" element={<AdminLayout><TransferReconciliationReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/slow-moving" element={<AdminLayout><SlowMovingReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/coupon-performance" element={<AdminLayout><CouponPerformanceReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/customer-retention" element={<AdminLayout><CustomerRetentionReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/catalogue-exceptions" element={<AdminLayout><CatalogueExceptionsReportPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/custom" element={<AdminLayout><CustomReportsPage /></AdminLayout>} />
          <Route path="/admindashboard/reports/channel-wise-sales" element={<AdminLayout><OperationalReportPage key="channel-wise-sales" kind="channel-wise-sales" /></AdminLayout>} />
          <Route path="/admindashboard/reports/customer-purchase-history" element={<AdminLayout><OperationalReportPage key="customer-purchase-history" kind="customer-purchase-history" /></AdminLayout>} />
          <Route path="/admindashboard/reports/product-profitability" element={<AdminLayout><OperationalReportPage key="product-profitability" kind="product-profitability" /></AdminLayout>} />
          <Route path="/admindashboard/reports/online-product-readiness"
            element={<AdminLayout><OperationalReportPage key="online-product-readiness" kind="online-product-readiness" /></AdminLayout>}
          />
          <Route
            path="/admindashboard/reports/purchase-returns"
            element={<AdminLayout><OperationalReportPage key="purchase-returns" kind="purchase-returns" /></AdminLayout>}
          />
          <Route path="/admindashboard/reports/sales-returns"
            element={<AdminLayout><OperationalReportPage key="sales-returns" kind="sales-returns" /></AdminLayout>}
          />
          <Route
            path="/admindashboard/reports/inventory-movement"
            element={<AdminLayout><OperationalReportPage key="inventory-movement" kind="inventory-movement" /></AdminLayout>}
          />
          <Route path="/admindashboard/reports/supplier-purchase-return"
            element={<AdminLayout><OperationalReportPage key="supplier-purchase-return" kind="supplier-purchase-return" /></AdminLayout>}
          />
          <Route
            path="/admindashboard/reports/stock-ageing"
            element={<AdminLayout><OperationalReportPage key="stock-ageing" kind="stock-ageing" /></AdminLayout>}
          />
          <Route path="/admindashboard/reports/discount-loyalty"
            element={<AdminLayout><OperationalReportPage key="discount-loyalty" kind="discount-loyalty" /></AdminLayout>}
          />
          <Route path="/admindashboard/reports/online-orders-detailed"
            element={<AdminLayout><OperationalReportPage key="online-orders-detailed" kind="online-orders-detailed" /></AdminLayout>}
          />
          <Route
            path="/admindashboard/reports/stock"
            element={
              <AdminLayout>
                <StockReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/product-wise-sale-stock"
            element={
              <AdminLayout>
                <ProductWiseSaleAndStockReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/purchase-sale-wise"
            element={
              <AdminLayout>
                <PurchaseSaleWiseReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/gstr"
            element={
              <AdminLayout>
                <GstrReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/purchase"
            element={
              <AdminLayout>
                <PurchaseReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/reports/agent-wise-sales"
            element={
              <AdminLayout>
                <AgentWiseSalesReportPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools"
            element={
              <AdminLayout>
                <ToolsDashboard />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/importcenter"
            element={
              <AdminLayout>
                <ImportCenterPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/importcenter/review/:jobId"
            element={
              <AdminLayout>
                <ImportJobReviewPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/exportcenter"
            element={
              <AdminLayout>
                <ExportCenterPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/datatemplates"
            element={
              <AdminLayout>
                <DataTemplatesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/importhistory"
            element={
              <AdminLayout>
                <ImportHistoryPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/auditlogs"
            element={
              <AdminLayout>
                <AuditLogsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/backuprestore"
            element={
              <AdminLayout>
                {process.env.NODE_ENV === "production" ? <Navigate to="/admindashboard/tools" replace /> : <BackupRestorePage />}
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/tools/systemjobs"
            element={
              <AdminLayout>
                {process.env.NODE_ENV === "production" ? <Navigate to="/admindashboard/tools" replace /> : <SystemJobsPage />}
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employees"
            element={
              <AdminLayout>
                <Employees />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employee-advances"
            element={
              <AdminLayout>
                <EmployeeAdvancesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employee-advances/new"
            element={
              <AdminLayout>
                <CreateEmployeeAdvance />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employee-advances/:advanceId"
            element={
              <AdminLayout>
                <EmployeeAdvanceDetailsPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employees/add"
            element={
              <AdminLayout>
                <AddEmployee />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employees/:id"
            element={
              <AdminLayout>
                <EmployeeDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/employees/:id/edit"
            element={
              <AdminLayout>
                <EditEmployee />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/attendance"
            element={
              <AdminLayout>
                <Attendance />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/attendance/punch-review"
            element={<AdminLayout><PunchReview /></AdminLayout>}
          />
          <Route
            path="/admindashboard/attendance/face-machines"
            element={
              <AdminLayout>
                <BiometricDevices />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/attendance/daily"
            element={
              <AdminLayout>
                <DailyAttendance />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/attendance/monthly"
            element={
              <AdminLayout>
                <MonthlyAttendance />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/attendance/corrections"
            element={
              <AdminLayout>
                <AttendanceCorrections />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/leave"
            element={
              <AdminLayout>
                <LeaveRequests />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/leave/apply"
            element={
              <AdminLayout>
                <ApplyLeave />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/leave/requests/:id"
            element={
              <AdminLayout>
                <LeaveDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/leave/balance"
            element={
              <AdminLayout>
                <LeaveBalance />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/leave/types"
            element={
              <AdminLayout>
                <LeaveTypes />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/leave/holiday-policies"
            element={
              <AdminLayout>
                <AttendanceHolidayPoliciesPage />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/hrms-reports/employee-summary"
            element={<AdminLayout><HRMSLegacyReports /></AdminLayout>}
          />
          <Route
            path="/admindashboard/hrms-reports/:reportKey"
            element={<AdminLayout><HRMSReportPage /></AdminLayout>}
          />
          <Route
            path="/admindashboard/hrms-reports"
            element={
              <AdminLayout>
                <HRMSReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/payroll"
            element={
              <AdminLayout>
                <Payroll />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/payroll/generate"
            element={
              <AdminLayout>
                <GeneratePayroll />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/payroll/off-cycle"
            element={
              <AdminLayout>
                <GenerateOffCyclePayroll />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/payroll/payslips"
            element={
              <AdminLayout>
                <Payslips />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/payroll/payslips/:id"
            element={
              <AdminLayout>
                <PayslipDetails />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/payroll"
            element={
              <AdminLayout>
                <PayrollReports />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/attendance"
            element={
              <AdminLayout>
                <AttendanceReport />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/analytics/employees"
            element={
              <AdminLayout>
                <EmployeeReport />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/settings"
            element={
              <AdminLayout>
                <Settings />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/settings/departments"
            element={
              <AdminLayout>
                <Departments />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/settings/roles"
            element={
              <AdminLayout>
                <Rolepermissions />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/settings/branches"
            element={
              <AdminLayout>
                <Branches />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/settings/designation"
            element={
              <AdminLayout>
                <DesignationManagement />
              </AdminLayout>
            }
          />
          <Route
            path="/admindashboard/profile"
            element={
              <AdminLayout>
                <Profile />
              </AdminLayout>
            }
          />
        </Routes>
        </WishlistProvider>
      </CustomerAuthProvider>
    </BrowserRouter>
  );
}
